export const scanDataEstimatedReimbursementsChartMessages = {
  totalEstimatedReimbursements: 'Total Estimated Reimbursements',
  estimatedMultiUnit: 'Estimated Multi-Unit',
  estimatedLoyalty: 'Estimated Loyalty',
};
